import axiosService from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import axios from '../../services/axios.service';
import { NotificationNew, NotificationParams } from './NotificationType';

let listRequest: any = null;
let typesRequest: any = null;
let counterRequest: any = null;

const notificationService = {
  getList(params: NotificationParams) {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axiosService.get(getEndpointBase(`notifications`), {
      cancelToken: listRequest.token,
      params: {
        filter: {
          model_type: params.targetType,
          model_id: params.targetId,
        },
        page: params.page,
        page_size: params.perPage
      },
    });
  },
  getTypes() {
    typesRequest && typesRequest.cancel();
    typesRequest = axios.CancelToken.source();
    return axiosService.get(getEndpointBase(`notifications/types`), {
      cancelToken: typesRequest.token,
    });
  },
  getCounter() {
    counterRequest && counterRequest.cancel();
    counterRequest = axios.CancelToken.source();
    return axiosService.get(getEndpointBase(`notifications/counter`), {
      cancelToken: counterRequest.token,
    });
  },
  create(data: NotificationNew) {
    return axiosService.post(getEndpointBase(`notifications`), {
      target_model: data.targetType,
      target_id: data.targetId,
      type: data.type,
      send_at: data.sendAt,
    });
  },
  markAsRead(id: string) {
    return axiosService.get(getEndpointBase(`notifications/${id}/read`));
  },
  markAllAsRead() {
    return axiosService.get(getEndpointBase(`notifications/read-all`));
  },
  remove(id: string) {
    return axiosService.delete(getEndpointBase(`notifications/${id}`));
  },
  removeAllRead() {
    return axiosService.delete(getEndpointBase('notifications/all-read'));
  },
};

export default notificationService;
